module.exports = __webpack_public_path__ + "img/il_Onboarding_Metrics.6b203018.svg";